import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { webAnalyticsComponent } from './web-analytics.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// import {m } from ';
import { MaterialModuleMobi, SharedModule } from 'shared-library';
MaterialModuleMobi

@NgModule({
  imports: [
    CommonModule,
    FormsModule,ReactiveFormsModule,
    MaterialModuleMobi,
    SharedModule
  ],
  exports:[webAnalyticsComponent],
  declarations: [webAnalyticsComponent]
})
export class webAnalyticsModule { }
